export default {
  reviewCompleteHeader: 'Przejrzyj i dokończ',
  participants: 'Uczestnicy',
  enterParticipantInfoText:
    'Proszę podać wymagane dane, aby przejść do realizacji zamówienia.',
  purchaser: 'Kupujący',
  firstName: 'Imię',
  lastName: 'Nazwisko',
  email: 'E-mail',
  optionalEmail: 'E-mail: (opcjonalnie)',
  'phone:': 'Telefon',
  participantFieldPlaceholder:
    'Dodaj nowego lub wybierz istniejącego uczestnika',
  reservationSummary: 'Podsumowanie rezerwacji',
  editParticipantsDetails: 'Edytuj dane uczestnika',
  participantDetails: 'Szczegóły',
  duplicatePurchaserText: 'Takie same jak kupującego',
  phone: 'Telefon',
  addParticipant: 'Dodatkowy {{tierLabel}}',
  participant: 'Uczestnik',
  removeParticipant: 'Usuń',
  experienceCheckoutCompleted: 'Realizacja zamówienia doświadczenia zakończona',
  experienceCartCheckout: 'Realizacja koszyka doświadczeń',
  experienceLimitReached:
    'Przepraszamy, to doświadczenie osiągnęło maksymalną liczbę uczestników',
  payment: 'Płatność',
  duration: 'Czas trwania',
  discountCode: 'Kod rabatowy',
  removeCode: 'Usuń kod',
  invalidCodeValidation: 'Nieprawidłowy kod kuponu',
  networkErrorDiscountCode: 'Coś poszło nie tak po naszej stronie',
  onlyOneCouponCodeAllowed: 'Dozwolony jest tylko jeden kod kuponu',
  creditCodeHasAlreadyBeenApplied: 'Kod kredytowy został już zastosowany',
  discount: 'Rabat',
  promo: 'Promocja',
  promoCode: 'Kod promocyjny',
  apply: 'Zastosuj',
  total: 'Suma',
  subTotal: 'Suma częściowa',
  includes: 'Zawiera',
  and: 'i',
  addHostNotes: 'Dodaj notatki dla gospodarza',
  brandAggreementText:
    'Zgadzam się lub poświadczam, że jestem upoważniony w imieniu uczestnika(ów) do wyrażenia zgody na warunki',
  termsAggreementValidation: 'Proszę zaakceptować warunki',
  firstNameValidation: 'Imię jest wymagane',
  lastNameValidation: 'Nazwisko jest wymagane',
  emailValidation: {
    emailRequiredText: 'E-mail jest wymagany',
    invalidEmail: 'Nieprawidłowy adres e-mail',
    not_specified: 'Nieprawidłowy adres e-mail',
  },
  phoneValidation: {
    'Invalid Phone Number': 'Nieprawidłowy numer telefonu',
    not_specified: 'Nieprawidłowy',
    phoneRequiredText: 'Numer telefonu jest wymagany',
  },
  participantFirstNameValidation: 'Imię uczestnika jest wymagane',
  participantLastNameValidation: 'Nazwisko uczestnika jest wymagane',
  complete: 'Dokończ',
  '404Message': 'Nie znaleziono',
  waiting: 'Oczekiwanie...',
  complimentary: 'Bezpłatne',
  confirmationHeader: 'Twoje doświadczenie zostało zarezerwowane!',
  confirmationText:
    'E-mail z potwierdzeniem został wysłany na adres {{email}} z dodatkowymi szczegółami',
  viewAll: 'Zobacz wszystkie doświadczenia',
  paymentMethod: 'Metoda płatności',
  creditCard: 'Karta kredytowa',
  roomCharge: 'Opłata za pokój',
  memberCharge: 'Opłata członkowska',
  roomOrReservationNumber: 'Numer pokoju lub numer potwierdzenia',
  roomNumber: 'Numer pokoju',
  roomNumberLegacy: 'Numer pokoju / Kod potwierdzenia',
  memberNumber: 'Numer członkowski',
  kicc: 'Easy Pay',
  chargeValidation: 'Numer pokoju i nazwisko są wymagane',
  memberNumberValidation: 'Numer członkowski jest wymagany',
  invalidRoomNumber: 'Numer pokoju jest nieprawidłowy',
  invalidRoomNumberLegacy:
    'Numer pokoju lub kod potwierdzenia jest nieprawidłowy',
  invalidMemberNumber: 'Numer członkowski jest nieprawidłowy',
  invalidPhoneNumber: 'Numer telefonu jest nieprawidłowy',
  requiredPhoneNumber: 'Numer telefonu jest wymagany',
  guestNameIsRequired: 'Imię gościa jest wymagane',
  roomNumberIsRequired: 'Numer pokoju jest wymagany',
  roomNumberIsRequiredLegacy:
    'Numer pokoju lub kod potwierdzenia jest wymagany',
  roomOrReservationNumberIsRequired:
    'Numer pokoju lub numer potwierdzenia jest wymagany',
  cardNumberIncomplete: 'Numer karty jest niekompletny',
  lastNameValidationError: 'Nazwisko jest wymagane',
  isReqd: 'jest wymagane',
  reservationCode: 'Numer rezerwacji/potwierdzenia',
  nonHotelGuest: 'Gość spoza hotelu',
  onPropertyGuest: 'Gość hotelowy',
  preArrivalGuest: 'Gość przed przyjazdem',
  cardNumber: 'Numer karty',
  pmsValidationErrorMessage:
    'Nieprawidłowe nazwisko, numer pokoju lub numer potwierdzenia',
  pmsDateValidationErrorMessage:
    'Przepraszamy! Data doświadczenia nie mieści się między datą przyjazdu a wyjazdu.',
  fullName: 'Imię i nazwisko',
  checkout: 'Realizacja zamówienia',
  editParticipants: 'Edytuj uczestników',
  private: 'Prywatne',
  browseAllExperieces: 'Przeglądaj wszystkie doświadczenia',
  payWithCreditCard: 'Zapłać kartą kredytową',
  payWithRoomCharge: 'Zapłać opłatą za pokój',
  payWithMemberCharge: 'Zapłać opłatą członkowską',
  payWith: 'Zapłać za pomocą',
  bookBulkErrorByCard:
    'Wystąpił problem z potwierdzeniem rezerwacji. Twoja karta nie została obciążona.',
  bookBulkErrorByRoomCharge: 'Nieprawidłowe nazwisko i numer pokoju.',
  bookBulkErrorByMemberCharge: 'Nieprawidłowe nazwisko i numer członkowski.',
  reviewCancellation: 'Przejrzyj anulowanie',
  selectAReservationToCancel: 'Wybierz rezerwację do anulowania',
  confirmCancellation: 'Potwierdź anulowanie',
  cancellable: 'Możliwe do anulowania',
  cancelled: 'Anulowane',
  deadlinePassed: 'Termin minął',
  noCancellations: 'Brak anulowań',
  reviewReschedule: 'Twoja rezerwacja',
  selectAReservationToReschedule:
    'Wybierz rezerwację do przełożenia na inny termin',
  confirmReservation: 'Potwierdź rezerwację',
  confirm: 'Potwierdź',
  selectADateAndTime: 'Wybierz datę i godzinę',
  noOtherSessionsAvailableForThisExperience:
    'Brak innych dostępnych sesji dla tego doświadczenia.',
  thisReservationCanNoLongerBeRescheduledPleaseEmail:
    'Tej rezerwacji nie można już przełożyć. Proszę napisać na adres {{brandEmail}}',
  thisReservationCannotBeRescheduled:
    'Tej rezerwacji nie można przełożyć na inny termin',
  noTimesAvailable: 'Brak dostępnych godzin',
  noBookingsAvailable: 'Brak dostępnych rezerwacji',
  youPaid: 'Zapłacono',
  refund: 'Zwrot',
  yourRefund: 'Twój zwrot',
  yourRefundWillBeProcessedToTheOriginalPayment:
    'Twój zwrot zostanie przetworzony na oryginalną metodę płatności.',
  thisReservationCanNoLongerBeCancelledPleaseEmail:
    'Tej rezerwacji nie można już anulować. Proszę napisać na adres {{brandEmail}}',
  reservationCancelled: 'Rezerwacja anulowana',
  thisReservationCannotBeCancelled: 'Tej rezerwacji nie można anulować',
  thisReservationHasAlreadyBeenCancelled: 'Ta rezerwacja została już anulowana',
  theHotel: 'hotel',
  cancelling: 'Anulowanie',
  somethingWentWrong: 'Coś poszło nie tak',
  previouslyRefunded: 'Wcześniej zwrócone',
  remainingBalance: 'Pozostałe saldo',
  notEnoughPoints: 'Niewystarczająca liczba punktów',
  notEnoughPointsDescription:
    'Nie masz wystarczającej liczby punktów World of Hyatt, aby dokończyć ten zakup.',
  currentPointsBalance: 'Aktualne saldo punktów: {{count, number}}',
  points: 'punkty',
  pointsWithCount_one: '{{count, number}} punkt',
  pointsWithCount_other: '{{count, number}} punktów',
  payWithHyattPoints: 'Zapłać punktami Hyatt',
  pleaseSignIn: 'Proszę się zalogować',
  worldOfHyattPoints: 'Punkty World of Hyatt',
  bookBulkErrorByNotEnoughSeats:
    'Niewystarczająca liczba miejsc na tę sesję. Proszę spróbować innej sesji.',
  phoneNumber: 'Numer telefonu',
  requestToBookConfirmationText:
    'E-mail z potwierdzeniem został wysłany na adres {{email}}',
  reservationRescheduled: 'Rezerwacja przełożona',
  yourReservationWasRescheduledTo: 'Twoja rezerwacja została przełożona na',
  viewExperiences: 'Zobacz doświadczenia',
  joinBook: 'Dołącz i zarezerwuj',
  signInBook: 'Zaloguj się i zarezerwuj',
  signAndJoin: 'Zaloguj się lub dołącz, aby zarezerwować',
  signAndJoinDescription:
    'Doświadczenia World of Hyatt FIND są dostępne wyłącznie dla członków World of Hyatt. Zaloguj się lub dołącz, aby rezerwować i zdobywać punkty. Wolisz nie dołączać? Nadal możesz rezerwować doświadczenia nieekskluzywne, usuwając doświadczenie World of Hyatt z koszyka.',
  promoOrFind: 'Kod promocyjny lub kod kredytowy Find',
  hyattTermsAndConditions: 'Regulamin',
  hyattTermsAndConditionsAgreement:
    'Potwierdzając tę rezerwację, akceptuję politykę anulowania. Zapoznałem/am się również z wykorzystaniem moich danych osobowych zgodnie z',
  hyattTermsAndConditionsLink: 'Polityką prywatności Hyatt',
  hyattWaiverText:
    'Kupując to doświadczenie, zgadzam się, rozumiem i przyjmuję do wiadomości, zarówno w swoim imieniu, jak i w imieniu każdej osoby uczestniczącej w zakupionym przeze mnie doświadczeniu (jeśli dotyczy), następujące',
  hyattWaiverLink: 'ogólne zrzeczenie się odpowiedzialności',
  priceDisclaimer: 'Zawiera opłaty przed opodatkowaniem',
  curatedRecommendations: 'Wybrane rekomendacje',
  moreExperiencesYouMightLike: 'Więcej doświadczeń, które mogą Ci się spodobać',
  similarExperiencesAvailableToBookDirectly:
    'Podobne doświadczenia dostępne do bezpośredniej rezerwacji',
  experiencesAvailableAroundYourBookingDate:
    'Doświadczenia dostępne w okolicach daty Twojej rezerwacji',
  confirmationEmailSent:
    'Wysłaliśmy potwierdzenie na adres {{email}} z dodatkowymi szczegółami.',
  youreBooked: 'Rezerwacja potwierdzona',
  purchaserInformation: 'Dane kupującego',
  requiredFieldIndicator: '* oznacza pole wymagane',
  resourceSelectionTitle: 'Wybierz opcje',
  resourceSelectionDescription:
    'Wybierz opcję dla każdej pozycji w rezerwacji.',
  resourceUnitLabel: '{{tierName}} {{number}}',
  selectResourceAttribute: 'Wybierz: {{attributeName}}',
  resourceValueSoldOut: '{{label}} (wyprzedane)',
  resourceValueUnavailableWith: '{{label}} (niedostępne z {{picks}})',
  resourceOptionsUnavailable:
    'Nie udało się wczytać opcji dla tego terminu. Spróbuj ponownie.',
  resourceOptionsRetry: 'Spróbuj ponownie',
  changeResourceSelections: 'Zmień wybór',
};
